import React from "react";
import BlogSeventeen from "../component/BlogSeventeen";

function BlogSeventeenContainer() {
  return <BlogSeventeen />;
}
export default BlogSeventeenContainer;
